import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CheckoutModalComponent } from '@core/checkout/checkout-modal/checkout-modal.component';
import { CheckoutFrom } from '@core/checkout/models/checkout-config';
import { MixpanelService } from '@core/services/tracking/mixpanel.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-premium',
  imports: [MatIcon],
  templateUrl: './premium.component.html',
})
export class PremiumComponent {
  private dialog = inject(MatDialog);
  private mixpanel = inject(MixpanelService);

  openPremium() {
    this.mixpanel.track('Settings upgrade your pocketguard button click');

    this.dialog.open(CheckoutModalComponent, {
      panelClass: 'full-screen-modal',
      autoFocus: false,
      data: {
        From: 'Settings - Upgrade button' as CheckoutFrom,
      },
    });
  }
}
